export default "__VITE_ASSET__f7rAQ9F0__"